import { MarketingAssetPermissions, MARKETING_ASSET_BROWSE_PERMISSIONS } from "@/marketing/permissions";

/**
 * The image library is a marketing workspace feature surfaced inside the travel admin, so its
 * codes live under `Marketing:` (see `src/marketing/permissions.ts`), not `Travel:`.
 */
export const AssetPermissions = MarketingAssetPermissions;

/** Open the library, browse and upload. */
export const ASSET_BROWSE_PERMISSIONS = MARKETING_ASSET_BROWSE_PERMISSIONS;

/**
 * Remove images and folders. Deleting affects every page that could pick the image, so it
 * takes the dedicated library grant or an all-of-marketing grant, not a landing page grant.
 */
export const ASSET_DELETE_PERMISSIONS = [
  MarketingAssetPermissions.ALL,
  MarketingAssetPermissions.ASSETS,
  MarketingAssetPermissions.CAMPAIGNS,
];
